import { Routes } from '@angular/router';

export const solicitudesRoutes: Routes = [
    {
      path: 'sol_inicio',
      loadComponent: () => import('./inicio/solicitudes.component'),
      data: {
        codmod: 'SOL',
        icon: 'home',
      },
    },
    {
      path: "sol_alta_empleados",loadChildren: () =>
          import("./alta-empleados/alta-empleados.routes").then(
          (m) => m.altaEmpleadosRoutes
        ),
      data: {
        codmod: "SOL",
        icon: "person_add",
      },
    },
    {
      path: "sol_baja_empleados",loadChildren: () =>
          import("./baja-empleados/baja-empleados.routes").then(
          (m) => m.bajaEmpleadosRoutes
        ),
      data: {
        codmod: "SOL",
        icon: "person_remove",
      },
    },
    {
      path: "sol_movimientos",loadChildren: () =>
          import("./movimientos/movimientos.routes").then(
          (m) => m.movimientosRoutes
        ),
      data: {
        codmod: "SOL",
        icon: "person_remove",
      },
    },
    {
      path: "sol_extension_contratos",loadChildren: () =>
          import("./contratos/contratos.routes").then(
          (m) => m.contratosRoutes
        ),
      data: {
        codmod: "SOL",
        icon: "person_remove",
      },
    },
]